export default __webpack_public_path__ + "static/fahrzeug-mwb-6f97365df00201d1396e47e09f50848a.jpg";